// extracted by mini-css-extract-plugin
export default {"heading":"PlayerList_heading__2A4nH"};